import React from 'react';
import _ from 'lodash';
import Promise from 'bluebird';

import {component, Component, makePath, navigateTo} from '../component';
import TopBanner from '../TopBanner';
import Avatar from '../Avatar';
import TeamPlayersList from '../TeamPlayersList';
import teamRoles from '../teamRoles';
import Api from '../../api';
import Games from '../Games';
import TournamentAnnouncement from '../TournamentAnnouncement';
import EditField from '../EditField';
import LinkButton from '../LinkButton';
import {CancelSmall, Warning, CheckedSmall} from '../icons';
import {HBox, VBox} from '../Box';
import {TableListRow, TableListCell} from '../TableList';
import ActionButton from '../ActionButton';
import Link from '../Link';
import Flag from '../Flag';
import ProfileStats from '../ProfileStats';
import Attention from '../Attention';
import LoadMoreButton from '../LoadMoreButton';
import DataEditButton from '../DataEditButton';
import EmptyPage from '../EmptyPage';

import {teamCheckActiveTournament} from './../teamCheckActiveTournament';
import notices from './../notices';

import teamApplicationStatuses from './../teamApplicationStatuses';

const freshTeam = {
  is_full: false,
  title: 'Моя новая команда',
  members: [{
    user: {},
    role: 1
  }],
  id: 0,
  description: ''
};

const newTeamID = 0;

export default class TeamDetails extends Component {

  constructor(props) {
    super(props);
    this.state = this.getUpdatedState(props);
  }

  loadApplications = async () => {
    let response = await Api.applications();
    this.props.data.cursor('applications').set(response.data);
  };

  getUpdatedState = (props) => {
    const data = props.data;
    const params = props.params;
    const isNew = props.isNew;

    const teamID = isNew ? newTeamID : params.id;

    if (isNew && !data.getIn(['teamData', teamID])) {
      freshTeam.members[0].user = data.get('user');
      data.cursor(['teamData', teamID]).set(freshTeam);
    }

    const team = data.cursor(['teamData', parseInt(teamID, 10)]);
    const teamId = team.get('id');
    const members = team.cursor(['members']);
    if (data.getIn(['teamData', parseInt(teamID, 10)])) {
      // XXX m => m
      var currentUserInMembers = members.hasData() && members.map(m => m).find(m =>
          m.getIn(['user', 'id']) === data.getIn(['user', 'id']));
      var isCaptain = currentUserInMembers &&
          currentUserInMembers.getIn(['role']) === teamRoles.captain.id;
    }

    return {
      currentUserInMembers, isCaptain, team, members, teamId
    };
  };

  componentWillReceiveProps(nextProps) {
    this.setState(this.getUpdatedState(nextProps))
  }

  componentWillMount() {
    if (this.state.isCaptain && !this.props.isNew) {
      this.loadApplications();
    }
  }

  createTeam = async () => {
    try {
      const response = await Api.teamCreate({title: this.state.team.get('title')});
      this.props.data.cursor(['userData', this.props.data.getIn(['user', 'id'])]).remove();

      const refreshManifest = await Api.manifest();
      this.props.data.setIn('user', refreshManifest.data.user);
      this.props.data.setIn('team', refreshManifest.data.team);

      navigateTo(makePath('teamDetails', {id: response.data.id}));
    } catch (e) {
      if (e.status === 409) {
        this.props.data.cursor('popup').set({
          icon: Warning,
          message: notices.nickNameExists,
          action: 'Понятно, подберу другое название',
          iconWidth: 128,
          iconHeight: 128,
          autoClose: true
        });
      }
    }
  };

  updateDescription = async () => {
    let {data} = await Api.teamUpdate({
      id: this.state.team.get('id'),
      description: this.state.team.get('description')
    });
    this.state.team.set(data);
  };

  async applicationAccept(applicationId, user) {
    const team = this.props.data.get('team');
    if(team && teamCheckActiveTournament(team, this.props.data.cursor('popup'))) {
      this.props.data.cursor('applications').forEach(application =>
        applicationId === application.get('id') ? application.setIn('status', teamApplicationStatuses['accepted'].id) : '');
      try {
        await Api.applicationsAccept({applicationId});
        this.state.members.set(this.state.members.toJS().concat({
          role: teamRoles.reserve.id,
          user: user.toJS()
        }));
      } catch (e) {
        this.props.data.cursor('applications').forEach(application =>
          applicationId === application.get('id') ? application.setIn('status', '') : '');
        this.props.data.cursor('popup').set({
          icon: Warning,
          message: notices.couldNotApproveRequest,
          action: 'Понятно',
          iconWidth: 128,
          iconHeight: 128,
          autoClose: true
        })
      }
    }
  }

  async applicationReject(applicationId) {
    this.props.data.cursor('applications').forEach((application) =>
        applicationId === application.get('id') ? application.setIn('status', teamApplicationStatuses['rejected'].id) : '');
    await Api.applicationsReject({applicationId});
  }

  loadMoreGames = async () => {
    this.props.data.setIn(['teamGames', this.state.teamId, 'loading'], true);
    await Api.teamGames(this.props.data, this.props.params, this.props.query);
    this.props.data.setIn(['teamGames', this.state.teamId, 'loading'], false);
  };

  loadMoreTournaments = async () => {
    this.props.data.setIn(['teamTournaments', this.state.teamId, 'loading'], true);
    await Api.teamTournaments(this.props.data, this.props.params, this.props.query);
    this.props.data.setIn(['teamTournaments', this.state.teamId, 'loading'], false);
  };

  leaveTeam = function(data, state) {
    const team = this.props.data.get('team');
    if( team && teamCheckActiveTournament(team, data.cursor('popup')) ){
      if(state.isCaptain && data.getIn(['team', 'member_count']) > 1){
        data.cursor('popup').set({
          icon: Warning,
          message: notices.captainCanNotLeaveTeam,
          action: 'Ок',
          iconWidth: 128,
          autoClose: true,
          iconHeight: 128
        });
        return;
      }

      data.cursor('popup').set({
        icon: Warning,
        message: notices.approveLeaveTeam,
        action: 'Покинуть команду',
        iconWidth: 128,
        iconHeight: 128,
        onAction: async function () {
          try {
            await Api.leaveTeam();
            data.cursor(['user', 'has_team']).set(false);
            data.cursor(['userData', data.getIn(['user', 'id']), 'has_team']).set(false);
            data.cursor(['userData', data.getIn(['user', 'id']), 'team']).set(null);
            data.cursor(['userData', data.getIn(['user', 'id']), 'member_role']).set(null);
            data.cursor(['popup', 'close']).set(true);
          } catch (r) {}
        }
      });
    }
  };

  applyToTeam = async function(team) {
    team.setIn('application_sent', true);
    await Api.teamApply({teamId: team.get('id')});
  };

  applyToTeamCancel = async function(team) {
    team.setIn('application_sent', false);
    await Api.teamApplyCancel({teamId: team.get('id')});
  };

  updateAttention = function(data, isNew){
    (this.props.isNew && !data.get('attentionShown')) && data.cursor('attention').set({
      text: notices.teamNameIsConstant
    });

    !isNew && data.cursor('attention').remove();
  };


  renderLoaded({data, params, query, isNew}, {currentUserInMembers, isCaptain, team, teamId, members}) {
    const justChangedStatus = data.cursor('applications').hasData()
        ? data.getIn('applications').find(a => a.get('status') === teamApplicationStatuses['accepted'].id)
        : undefined;

    const showApplications = !!(this.state.isCaptain
      && data.cursor('applications').hasData()
      && (!this.state.team.get('is_full') || justChangedStatus));

    if(isNew && data.getIn(['user', 'has_team'])){
      let content = <div className="EmptyPage-Caption">Чтобы создать новую команду, необходимо покинуть ту, в составе которой ты сейчас находишься.</div>;
      return <EmptyPage content={content}></EmptyPage>;
    }

    let membership = null;
    if(!isNew && data.get('user')) {
      if (data.getIn(['user', 'has_team'])) {
        if (data.getIn(['team', 'id']) === this.state.team.get('id')) {
          membership = <DataEditButton text='покинуть команду' onClick={this.leaveTeam.bind(this, data, this.state)} />;
        }
      }else if(!this.state.team.get('is_full')){
        membership = this.state.team.get('application_sent') ?
          <div>
            <div className="PlayerDetails-TeamContainerCaption PlayerDetails-InvitationSent">Заявка отправлена</div>
            <DataEditButton onClick={this.applyToTeamCancel.bind(this, this.state.team)} text='отменить заявку' />
          </div> :
          <DataEditButton text='подать заявку' onClick={this.applyToTeam.bind(this, this.state.team)}/>;
      }
    }

    this.updateAttention(data, isNew);


    return (
      <div>
        <TopBanner data={data} size='regular'>
          <div className="PlayerDetails-TeamApplication PlayerDetails-TeamContainerCaption">
            {membership}
          </div>
          <Avatar type={isNew ? 'TeamNew' : 'Team'} popup={data.cursor('popup')} isOwner={isCaptain} data={team} isNew={isNew} league={team.get('league')} leagueClassName="League--teamAvatar"/>
          {/* TODO generalize or do not use `PlayerDetails-` selector */}
          <h2 className='PlayerDetails-About'>
            {isCaptain && !isNew
              ? <EditField
                  updateMethod={this.updateDescription}
                  valueKey='description'
                  defaultValue='Добавить описание'
                  data={this.state.team}
                  />
                  : <div>{this.state.team.get('description')}</div>
              }
            </h2>
            {this.props.isNew
                ? <LinkButton text='Сохранить' onClick={this.createTeam} />
                : <ProfileStats data={this.state.team} className='PlayerDetails-Stats' />
            }
          </TopBanner>
          {showApplications &&
          <HBox width={4}>
            <h3 className='PlayerDetails-ApplicationTeamHeader'>Запросы на вступление в команду</h3>
            {data.cursor('applications').hasData() && data.getIn('applications').map((application) => {
              const itemImage = application.getIn(['user', 'image']);
              const bgImage = itemImage
                  ? itemImage + '?crop=1&w=88&h=88'
                  : require('../../img/teamEmptyAvatarSquare.png');
              return <TableListRow height={88} bordered={true} key={application.get('id')}>
                <TableListCell width={88} type='Logo' >
                  <Link name='playerDetails' className="TableListCell-Avatar"  params={{id: application.getIn(['user', 'id'])}} style={{
                        backgroundImage: `url(${bgImage})`,
                        width: 88,
                        height: 88
                      }} />
                </TableListCell>
                <TableListCell width={648} type='Primary'>
                  <div className='PlayerDetails-ApplicationTeamTitle'>
                    <Link name='playerDetails' params={{id: application.getIn(['user', 'id'])}}>
                      {application.getIn(['user', 'nickname'])}
                    </Link>
                  </div>
                  <div className='PlayerDetails-ApplicationTeamCountry'>
                    <Flag country={application.getIn(['user', 'country'])} outputName={true} />
                  </div>
                </TableListCell>

                {application.get('status') !== teamApplicationStatuses['new'].id
                    ?
                    <TableListCell width={440} type='Action'>
                      <div className='TableListCell-ItemState'>
                        <div className='TableListCell-ItemStateStatus'>
                          {application.get('status') === teamApplicationStatuses['accepted'].id && <CheckedSmall className='TableListCell-IconChecked' />}
                          {application.get('status') === teamApplicationStatuses['rejected'].id && <CancelSmall className='TableListCell-IconChecked' />}
                        </div>
                        <div>
                          {application.get('status') === teamApplicationStatuses['accepted'].id && 'Заявка принята'}
                          {application.get('status') === teamApplicationStatuses['rejected'].id && 'Заявка отклонена'}
                        </div>
                      </div>
                    </TableListCell>
                    :
                    <TableListCell width={440} type='Action'>
                      <ActionButton text='Принять' arrow={true} className='PlayerDetails-ButtonAccept'
                                    onClick={this.applicationAccept.bind(this, application.getIn(['id']), application.getIn(['user']))} />
                      <ActionButton icon={<CancelSmall />} className='PlayerDetails-ButtonReject'
                                    onClick={this.applicationReject.bind(this, application.getIn(['id']))} />
                    </TableListCell>
                }
              </TableListRow>
            })}
          </HBox>
          }

        {
          !isNew &&
            <div>
              <TeamPlayersList data={this.state.members} isOwner={this.state.isCaptain}
                               currentMember={this.state.currentUserInMembers}
                               isNew={this.props.isNew}
                               popup={data.cursor('popup')} dataObject={data} />

              <HBox width={4}>
                <VBox width={2} isContainer>
                  {data.cursor(['teamGames', teamId, 'list']).hasData()
                      ? <Games type="vertical" data={data.cursor(['teamGames', teamId, 'list'])} />
                      : <div className="PlayerDetails-EmptyBlock">
                          матчи не сыграны
                        </div>
                  }
                </VBox>
                <VBox isContainer width={2}>
                  {data.cursor(['teamTournaments', teamId, 'list']).hasData()
                      ? data.cursor(['teamTournaments', teamId, 'list']).map(tournament =>
                          <TournamentAnnouncement picPosition="left" description
                                                  details isListItem data={tournament} />)
                      : <div className="PlayerDetails-EmptyBlock">
                          турниры не сыграны
                        </div>
                  }
                </VBox>
              </HBox>
              <HBox width={4}>
                <VBox width={2} isContainer>
                  {!data.getIn(['teamGames', teamId, 'noMore']) &&
                      <LoadMoreButton text="игр" onClick={this.loadMoreGames}
                                      loading={data.getIn(['teamGames', teamId, 'loading'])} />
                  }
                </VBox>
                <VBox width={2} isContainer>
                  {!data.getIn(['teamTournaments', teamId, 'noMore']) &&
                      <LoadMoreButton text="турниров" onClick={this.loadMoreTournaments}
                                      loading={data.getIn(['teamTournaments', teamId, 'loading'])} />
                  }
                </VBox>
              </HBox>
            </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/TeamDetails.js